
/**
 * Formats a key from camelCase to Title Case with spaces
 */
export const formatKeyName = (key: string): string => {
  return key
    .replace(/([A-Z])/g, ' $1') // Add space before capital letters
    .replace(/^./, (str) => str.toUpperCase()); // Capitalize first letter
};

/**
 * Formats a value for display
 */
export const formatValue = (value: any): string => {
  if (typeof value === 'string') {
    return value.replace(/_/g, " ");
  } else if (Array.isArray(value)) {
    return value.join(", ");
  } else {
    return String(value);
  }
};
